import apiClient from '@/api/client';
import type { RevenueSummary } from '@/types/revenue';

export const getRevenue = async (companyId?: string): Promise<RevenueSummary[]> => {
  const params = companyId ? { companyId } : {};
  const response = await apiClient.get<RevenueSummary[]>('/revenue', { params });
  return response.data;
};

export const syncStripeData = async (): Promise<{ importedCount: number }> => {
  const response = await apiClient.post<{ importedCount: number }>('/revenue/sync');
  return response.data;
};
